<template>
  <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">
          #{{product.parent}} <small class="has-text-grey-light">| {{product.brand}}</small>
        </p>
        <button type="button" class="delete" @click="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <div class="container is-widescreen">
          <div class="Product columns">
            <div class="column is-full-mobile is-half-table is-two-fifths-desktop">
              <div class="Product-photo">
                <figure class="Product-zoom" @mousemove="zoom($event)" :style="'background-image: url(' + selected.image.large + ')'">
                  <img :src="selected.image.medium" v-if="selected.image">
                </figure>
              </div>
              <div class="Product-photoThumbnail">
                <ul class="Product-thumbnail Product-thumbnail--justified">
                  <li class="Product-thumbnailItem" :class="{isActive: selected.image.small === thumbnail.small}" v-for="(thumbnail, index) in thumbnails" :key="index" @click="selected.image = thumbnail">
                    <img class="Product-thumbnailItemImage" :src="thumbnail.small">
                  </li>
                </ul>
              </div>
            </div>
            <div class="column">
              <div class="product__info">
                <h1 class="Product-title mb-6">{{product.title}}</h1>
                <div class="my-6">
                  <h3>COLORES</h3>
                  <div class="Product-thumbnail">
                    <div class="has-text-centered" v-for="color in product.colors" :key="color.colorCode">
                      <div class="Product-thumbnailItem Product-thumbnailItem--isChecked Product-thumbnailItem--boxed Product-thumbnailItem--rounded Product-thumbnailItem--shadow" :class="{isChecked: selected.color === color.colorCode}" @click="setColor(color)">
                        <img class="Product-thumbnailItemImage Product-thumbnailItemImage--cover" :src="color.colorSW">
                      </div>
                      <span class="Product-thumbnailItemLabel">{{color.colorCode}}</span>
                    </div>
                  </div>
                </div>
                <div class="my-6">
                  <h3>TALLAS</h3>
                  <div class="columns is-multiline is-mobile is-gapless">
                    <div class="column is-narrow Product-size" v-for="size in orderBy(sizes,'talla') " :key="size.size" :class="{isActive: selected.size && selected.size.size === size.size}" @click="setSize(size)">
                      {{size.size}}
                      <div class="Product-thumbnailItemTag">
                        <transition name="slide" mode="out-in">
                          <span v-if="size.quantity % 2 === 0" key="x">
                            {{ +size.quantity }}
                          </span>
                          <span v-else key="y">
                            {{ +size.quantity }}
                          </span>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns my-6">
                  <div class="column is-narrow">
                    <b-numberinput type="is-dark" :disabled="!selected.size" controls-position="compact" min="1" max="100" v-model="quantity"></b-numberinput>
                  </div>
                  <div class="column">
                    <b-button ref="addToCart" :disabled="!selected.size" @click="addToCart(selected.size, quantity)" type="is-dark" icon-left="shopping" expanded>Agregar a la bolsa</b-button>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <h3 class="has-text-centered py-4">DESCRIPCIÓN</h3>
              <div class="Divider"></div>
              <ProductDescription :description="product.descriptionHTML" />
            </div>
          </div>
        </div>
      </section>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import ProductDescription from './ProductDescription.vue'
  import Vue2Filters from 'vue2-filters'
  export default {
    components: {
      ProductDescription
    },
   mixins: [Vue2Filters.mixin],
    props: {
      product: Object
    },
    data () {
      return {
        selected: {
          image: {
            small: null,
            medium: null,
            large: null,
          },
          color: null,
          size: null
        },
        image: null,
        color: null,
        sizes: [],
        thumbnails: [],
        quantity: 1
      }
    },
    computed: {
      ...mapGetters ([
        'getCart'
      ])
    },
    watch: {
      getCart (cart) {
        this.sizes = this.sizes.map(size => {
          var item = cart.filter(o => o.ean === size.ean)
          if (item.length) {
            size.quantity = item[0].quantity
          }
          return size
        })
      }
    },
    mounted () {
      this.setColor(this.product.colors[0])
    },
    methods: {
      ...mapActions([
        'setCart'
      ]),
      addToCart (product, quantity) {
        // EAN, Referencia, Talla, Color, Unidades pedidas
        var instance = this
        instance.setCart({
          ean: product.ean,
          reference: product.reference,
          size: product.size,
          color: product.colorCode,
          quantity: quantity,
          name: instance.product.title,
          image: instance.selected.image
        })

        instance.$buefy.snackbar.open({
          duration: 5000,
          message: `Se ha añadido <b>${instance.quantity}</b> <u><em>${instance.product.title}</em></u> a la bolsa.`,
          type: 'is-danger',
          position: 'is-top',
          actionText: 'Deshacer',
          queue: false,
          onAction: () => {
            instance.setCart({
              ean: product.ean,
              reference: product.reference,
              size: product.size,
              color: product.colorCode,
              quantity: -quantity,
              name: instance.product.title,
              image: instance.selected.image
            })
            this.$buefy.toast.open({
              message: `Se han revertido las <b>${instance.quantity}</b> unidades de <u><em>${instance.product.title}</em></u>.`,
              type: 'is-success',
              position: 'is-bottom'
            })
          }
        })
      },
      setColor (color) {
        var instance = this
        var regex = new RegExp(/[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi)
        if(color.images.includes('Sin Imagen')){
            instance.selected.image ='';
        } else {
            instance.thumbnails = color.images.match(regex).filter(path => {
              return path.indexOf('/video/') === -1
            }).map(image => {
              image = 'https://' + image
              return {
                small: image.replace('/upload/', '/upload/w_60,c_scale/'),
                medium: image.replace('/upload/', '/upload/w_800,c_scale/'),
                large: image
              }
            })
            instance.selected.image = instance.thumbnails[0]
        }
        instance.sizes = color.sizes
        instance.selected.color = color.colorCode || instance.product.colors[0].colorCode
        instance.selected.size = null
      },
      setSize (size) {
        if (this.selected.size === size) {
          this.addToCart(size, 1)
        }
        this.selected.size = size
        console.log('size', size)
      },
      // setSizes (color) {
      //   var instance = this
      //   var sizes = []
      //   color.sizes.map(size => {
      //     sizes.push(size)
      //   })
      //   instance.sizes = [...sizes.reduce( (mp, o) => {
      //     if (!mp.has(o.size)) mp.set(o.size, { ...o, count: 0 })
      //     mp.get(o.size).count++
      //     return mp
      //   }, new Map).values()]
      // },
      zoom (e) {
        if (this.isMobile) return
        // console.log('isMobile()', this.isMobile)
        var offsetX, offsetY, x, y
        var zoomer = e.currentTarget;
        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
        x = offsetX / zoomer.offsetWidth * 100
        y = offsetY / zoomer.offsetHeight * 100
        zoomer.style.backgroundPosition = x + '% ' + y + '%'
      }
    }
  }
</script>
<style lang="scss" scoped>
/* ----- Variables ----- */
$color-primary: #4c4c4c;
$color-secondary: #a6a6a6;
$color-tertiary: #efefef;
$color-highlight: #ff3f40;

.Product {
  &-title {
    color: $color-primary;
    font-size: 3rem;
    font-weight: 300;
    letter-spacing: 1.2px;
    line-height: 3rem;
    margin-bottom: 0.1em;
  }
  &-subtitle {
    font-size: 0.7em;
    color: $color-secondary;
  }
  &-photo {
    border-radius: 6px 6px 0 0;
    line-height: 0;
    overflow: hidden;
  }
  &-zoom {
    & img:hover {
      @include from($tablet) {
        opacity: 0;
      }
    }
    img {
      transition: opacity .5s;
    }
    background-position: 50% 50%;
    position: relative;
    overflow: hidden;
    cursor: zoom-in;
  }
  &-photoThumbnail {
    background-color: #fff;
    border-radius: 0 0 6px 6px;
  }
  &-size {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }
  &-thumbnail {
    display: flex;
    padding: 0.7em 1em;
  }
  &-thumbnail--justified {
    justify-content: space-around;
    margin-right: 0;
  }
  &-thumbnailItem {
    border: 1px solid #fff;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 55px;
    overflow: hidden;
    position: relative;
    margin-right: 10px;
  }
  &-thumbnailItemTag,
  &-thumbnailItem--tag:before {
    background: #e2e2e2;
    border: 1px solid #bbb;
    border-top: 0;
    border-right: 0;
    border-bottom-left-radius: 3px;
    font-size: 10px;
    line-height: 10px;
    padding: 0px 2px 1px;
    position: absolute;
    top: 0;
    right: 0;
  }
  &-thumbnailItem--tag:before {
    content: attr(data-count);
  }
  &-thumbnailItem--boxed {
    width: 40px;
    height: 40px;
  }
  &-thumbnailItem--rounded {
    border-radius: 100%;
  }
  &-thumbnailItem--shadow {
    border: 1px solid #bbb;
  }
  &-thumbnailItemImage {
    border-radius: inherit;
    border: 2px solid transparent;
    transition: .2s ease;
    &:hover {
      transform: scale(1.1);
    }
  }
  &-thumbnailItemImage--cover {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &-thumbnailItemLabel {
    color: #b5b5b5;
    font-weight: 300;
    font-size: .8rem;
  }
}
.Product-size.isChecked,
.Product-size.isActive,
.Product-thumbnailItem.isChecked,
.Product-thumbnailItem.isActive {
  border-color: $color-primary;
  box-shadow: 0 0 0 1px $color-primary;
  .Product-thumbnailItemImage {
    border-color: #fff;
    transform: scale(1);
  }
}
.Product-thumbnailItem.isChecked:after {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%23fff'%3E%3Cpolyline points='2,13 9,20 24,5' stroke-width='4' fill='none'/%3E%3C/svg%3E"), radial-gradient(rgba(44,42,41,.3),rgba(44,42,41,0) 66.66667%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 1.44em, cover;
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.Photo {
  &-album {
    padding: 0.7em 1em;
    border-radius: 0 0 6px 6px;
    background-color: #fff;
    display: flex;
    justify-content: space-around;
  }
  &-albumItem {
    background: $color-tertiary;
    border: 1px solid #fff;
    border-radius: 3px;
    float: left;
    width: 55px;
    height: 66px;
    overflow: hidden;
  }
  &-albumItemImage {
    border-radius: 3px;
    transition: .2s ease;
    &:hover {
      transform: scale(1.1);
    }
  }
}
.Photo-albumItem.isActive {
  border-color: $color-primary;
  .Photo-albumItemImage {
    transform: scale(1.1);
  }
}

.slide-enter {
  opacity: 0.5;
}

.slide-enter-active,
.slide-leave-active {
  transition: all .15s;
}

.slide-enter-to,
.slide-leave {
  opacity: 1;
}

.slide-leave-to {
  opacity: 0;
  transform: blur(8px);
}

::v-deep .wait {
  display: block;
  position: fixed;
  top: inherit;
  right: inherit;
  transition: all 2s ease-out;
}
.columns.is-gapless > .column.Product-size {
  margin-bottom: 10px;
  margin-right: 5px;
  padding: 0.75rem !important;
}
::v-deep .animate {
  top: 10px;
  right: 10px;
}
</style>